<template>
  <router-view />
</template>

<style lang="scss">
#app {
  font-family: Helvetica Neue, PingFang SC, HanHei SC, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

body {
  user-select: none;
}
</style>
